/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _typeof } from '../../_chunks/dep-ae1abe1d.mjs';
import { defineComponent, createVNode, mergeProps } from 'vue';
import { SearchIcon } from 'tdesign-icons-vue-next';
import { Input } from '../../input/index.mjs';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { useGlobalIcon } from '../../hooks/useGlobalIcon.mjs';
import '../../input/input.mjs';
import '../../_chunks/dep-c3626417.mjs';
import '../../_chunks/dep-b011b919.mjs';
import '../../input/props.mjs';
import '../../form/hooks.mjs';
import '../../hooks/tnode.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-f50ac97c.mjs';
import '../../_chunks/dep-94585de3.mjs';
import '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-06221fe2.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_chunks/dep-d7053a2c.mjs';
import '../../_chunks/dep-f3e3393e.mjs';
import '../../_chunks/dep-0fa7026c.mjs';
import '../../_chunks/dep-31dc9d09.mjs';
import '../../_chunks/dep-b9d74a58.mjs';
import '../../utils/render-tnode.mjs';
import '../../_chunks/dep-ff1c0573.mjs';
import '../../_chunks/dep-42be3824.mjs';
import '../../_chunks/dep-a11a63ea.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-ad1accf9.mjs';
import '../../_chunks/dep-a255de71.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-ebfafd52.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../input/useInput.mjs';
import '../../_chunks/dep-fc63c737.mjs';
import '../../_chunks/dep-2a2a0e63.mjs';
import '../../form/const.mjs';
import '../../hooks/index.mjs';
import '../../hooks/icon.mjs';
import '../../hooks/slot.mjs';
import '../../hooks/useCommonClassName.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-adebe2ce.mjs';
import '../../_chunks/dep-bd3d75f1.mjs';
import '../../_chunks/dep-2b8d75e2.mjs';
import '../../_chunks/dep-8f44163a.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-1f0070bb.mjs';
import '../../_chunks/dep-9d0d32fd.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-67dfe9c7.mjs';
import '../../_chunks/dep-a0bd2e3a.mjs';
import '../../_chunks/dep-91208ac3.mjs';
import '../../_chunks/dep-1041f7d7.mjs';
import '../../_chunks/dep-b32fb318.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-99a0abba.mjs';
import '../../_chunks/dep-9d5ee0e1.mjs';
import '../../config-provider/type.mjs';
import '../../hooks/useDefaultValue.mjs';
import '../../hooks/useDestroyOnClose.mjs';
import '../../hooks/useKeepAnimation.mjs';
import '../../hooks/useRipple.mjs';
import '../../utils/set-style.mjs';
import '../../hooks/useVirtualScroll.mjs';
import '../../hooks/useVModel.mjs';
import '../../input/useLengthLimit.mjs';
import '../../_common/js/log/index.mjs';
import '../../_common/js/log/log.mjs';
import '../../_common/js/utils/helper.mjs';
import '../../_chunks/dep-56ceb7ce.mjs';
import '../../_chunks/dep-e00db566.mjs';
import '../../_chunks/dep-fdde96c5.mjs';
import '../../_chunks/dep-961339ce.mjs';
import '../../input/useInputEventHandler.mjs';
import '../../input/useInputWidth.mjs';
import '../../input/input-group.mjs';
import '../../input/input-group-props.mjs';
import '../../utils/withInstall.mjs';
import './style/css.mjs';
import '../../input/type.mjs';

var Search = defineComponent({
  name: "TTransferSearch",
  props: {
    value: {
      type: String,
      "default": ""
    },
    search: {
      type: [Boolean, Object],
      "default": false
    },
    placeholder: {
      type: String,
      "default": ""
    },
    onChange: Function
  },
  setup: function setup(props) {
    var classPrefix = usePrefixClass();
    var _useGlobalIcon = useGlobalIcon({
        SearchIcon: SearchIcon
      }),
      SearchIcon$1 = _useGlobalIcon.SearchIcon;
    var handleChange = function handleChange(value, changeCtx) {
      var _props$onChange;
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, {
        value: value,
        e: changeCtx.e
      });
    };
    var inputProps = _typeof(props.search) === "object" ? props.search : {
      clearable: true
    };
    return function () {
      return createVNode("div", {
        "class": "".concat(classPrefix.value, "-transfer__search-wrapper")
      }, [createVNode(Input, mergeProps(inputProps, {
        "defaultValue": props.value,
        "onChange": handleChange,
        "placeholder": props.placeholder
      }), {
        "default": function _default() {
          return [createVNode(SearchIcon$1, {
            "slot": "suffix-icon"
          }, null)];
        }
      })]);
    };
  }
});

export { Search as default };
//# sourceMappingURL=transfer-search.mjs.map
